module.exports = __webpack_public_path__ + "static/media/link.271fc514.png";